module.exports = __webpack_public_path__ + "assets/img/ozmo-instagram.82628276.png";